'use client'
import React, { useState } from 'react';
import Head from 'next/head'
import Image from 'next/image'
import Link from 'next/link';
import NavBarLanding from '@/components/NavBarLanding';
import Footer from '@/components/Footer';
import { SignFrom } from '@/components/Sign';
import { posts } from './blogPosts';
import { Post } from './PostType';
import BlogCard from './BlogCard';

const Blog: React.FC = () => {
    const [signValue, setSignValue] = useState<string>('signup');
    const [toggleSignForm, setToggleSignForm] = useState<boolean>(false);


    return (
        <>
            <Head>
                <title>Eurekia !</title>
                <meta name="description" content="Generated by webzh" />
                <meta name="viewport" content="width=device-width, initial-scale=1" />
                <link rel="icon" href="/favicon.ico" />
            </Head>

            <main className="w-full items-center justify-center flex-col bg-main relative gap-4">
                {
                    toggleSignForm ?

                        <div className='w-full sm:h-full h-screen flex justify-center items-center'>
                            <style global jsx>{`
    #__next {
        height:100vh;
        width:100vw;
        overflow:hidden
      }
`}</style>
                            <div onClick={() => setToggleSignForm(false)} className='z-50 w-full h-full fixed top-0 left-0 flex justify-center items-center backdrop-blur-md bg-black bg-opacity-10'>
                            </div>
                            <div className='z-[1000] fixed flex justify-center'>
                                <SignFrom signValue={signValue} />
                            </div>
                        </div>
                        : null
                }
                < NavBarLanding
                    signValue={signValue as string}
                    setSignValue={setSignValue}
                    toggleSignForm={toggleSignForm}
                    setToggleSignForm={setToggleSignForm}
                />
                <section className="w-full flex flex-col items-center h-auto pt-[150px]">

                    <h1 className='font-medium text-3xl lg:text-[2.4vw] leading-tight flex sm:items-start items-center justify-center flex-col text-center'>
                        Blog
                    </h1>
                    <div className=" p-8 w-full max-w-[1280px] mx-auto rounded">
                        <div className="container mx-auto p-4">
                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 gap-4">
                                {posts.map((post: Post) => (
                                    <BlogCard key={post.id} post={post} />
                                ))}
                            </div>
                        </div>
                    </div>
                </section>
                <Footer />

            </main>
        </>

    );
};

export default Blog;